<template>
  <div>
    <JobDirect v-if="isDirect" />
    <JobAgent v-else-if="isAgent" />
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import JobDirect from '@/pages/candidate/job/direct/Index.vue';
import JobAgent from '@/pages/candidate/job/agent/AgentSearch.vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const isDirect = ref(false);
const isAgent = ref(false);

onMounted(() => {
  isDirect.value = route.query.direct === 'true';
  isAgent.value = route.query.agent === 'true';
  if (isDirect.value == false && isAgent.value == false) return (isAgent.value = true);
});
</script>
